import { css } from '@emotion/css'

export const optionClass = css({ overflowX: 'hidden' })
export const listboxClass = css({ maxHeight: '20vh' })
export const primaryClass = css({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
})
